import {useTranslation} from 'react-i18next'
import {DatePickerV2} from '../../../../components/DatePickerV2/DatePickerV2'
import {TextInputV2} from '../../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {filterSelector, setFilterLogSAP} from '../../../../redux/slices/filterSlices'
import './RowFilter.scss'
import {TRowFilter} from '../../../../components/Table/Table'
import {Selection} from '../../../../components/Selection'
import { useLogSAPTypes } from 'src/hooks/useLogSAPTypes'

export const RowFilter = () => {
  const {t} = useTranslation()
  const {filterLogSAP: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const {options: logTypes} = useLogSAPTypes()


  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterLogSAP({...filter, ...value}))
  }

  return (
    <TRowFilter>
      <td>
        <div style={{margin: '2px 0'}}>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('No. Transaction')}
          value={filter?.transaction_number}
          onChange={({target}) => handleFilterChange({transaction_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Request')}
          value={filter?.request}
          onChange={({target}) => handleFilterChange({request: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={'IP ' + t('Response')}
          value={filter?.ip_response}
          onChange={({target}) => handleFilterChange({ip_response: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Response')}
          value={filter?.response}
          onChange={({target}) => handleFilterChange({response: target.value})}
        />
      </td>
      <td>
        <Selection
          data={logTypes}
          placeholder={t('Request Type')}
          value={filter?.request_type || ''}
          onChange={(type) => handleFilterChange({request_type: type})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('Created At')}
          startDate={filter?.created_at ?? ''}
          onChange={({startDate}) => handleFilterChange({created_at: startDate})}
          isSelectsRange={false}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('Updated At')}
          startDate={filter?.updated_at ?? ''}
          onChange={({startDate}) => handleFilterChange({updated_at: startDate})}
          isSelectsRange={false}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Message')}
          value={filter?.message}
          onChange={({target}) => handleFilterChange({message: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Status')}
          value={filter?.status}
          onChange={({target}) => handleFilterChange({status: target.value})}
        />
      </td>
    </TRowFilter>
  )
}
